// src/components/CellEditorPopup.js
import React, { useState } from 'react';
import './CellEditorPopup.css';

const CellEditorPopup = ({ cell, onUpdate, onClose }) => {
  const [hintBorders, setHintBorders] = useState({
    top: false, right: false, bottom: false, left: false,
  });

  const handleSave = () => {
    const bordersArray = Object.entries(hintBorders).filter(([, value]) => value).map(([key]) => key);
    onUpdate({ type: 'hint', r: cell.r, c: cell.c, borders: bordersArray });
    onClose();
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <h4>Set Hint Borders</h4>

        <div className="hint-checkboxes">
          <label><input type="checkbox" onChange={(e) => setHintBorders(p => ({...p, top: e.target.checked}))} /> Top</label>
          <label><input type="checkbox" onChange={(e) => setHintBorders(p => ({...p, right: e.target.checked}))} /> Right</label>
          <label><input type="checkbox" onChange={(e) => setHintBorders(p => ({...p, bottom: e.target.checked}))} /> Bottom</label>
          <label><input type="checkbox" onChange={(e) => setHintBorders(p => ({...p, left: e.target.checked}))} /> Left</label>
        </div>

        <div className="popup-actions">
          <button onClick={handleSave} className="popup-button save">Save</button>
          <button onClick={onClose} className="popup-button cancel">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default CellEditorPopup;